<template>

  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>
  <div class="cell small-12">
    <h1>Auto Enrolment (AE) Group</h1>
    <p>Many pension schemes organise employees into AE groups (sometimes called “categories” or “tiers”) and most pensions only have one.</p>
    <p>
      AE groups allow groups of employees to have different contribution levels and
      <a href="#" @click.prevent="displayEarningsBandHelp = true">earnings bands</a> for calculation.
    </p>
  </div>

  <div class="help-panel" v-if="displayEarningsBandHelp" style="position:relative;">
    <button
      type="button"
      @click="displayEarningsBandHelp = false"
      aria-label="Close"
      style="position:absolute; top:8px; right:8px; background:transparent; border:none; font-size:38px; line-height:1; cursor:pointer;"
    >&times;</button>

    <p><b>What are earnings bands?</b></p>
    <p>Some pensions use what’s called qualifying earnings — this means only the portion of an employee’s earnings between a lower and upper limit is used to work out contributions.</p>
    <p>Other pensions calculate contributions from the first pound earned.</p>
  </div>

    <div class="cell small-12">
      <EditableTable
        v-model="formData.aeGroups"
        :columns="columns"
        :buttonName="'Add AE Group'"
      />
    </div>




</template>


<script setup>

import { ref, onMounted } from 'vue'
import EditableTable from '@/components/controls/EditableTable.vue';

const error = ref([]);

const displayEarningsBandHelp = ref(false);

const props = defineProps({
  formData: Object
})


const columns = [
  { field: 'aegroup', label: 'Group Name', type: 'text', placeholder: 'Group name' },
  { field: 'eePerc', label: 'Employee Percentage', type: 'text', placeholder: 'Employee %' },
  { field: 'erPerc', label: 'Employer Percentage', type: 'text', placeholder: 'Employer %' },
  { field: 'qualifyingEarnings', label: 'Qualifying Earnings', type: 'checkbox' },
]


const validateStep = () => {
  error.value = [];

  if (props.formData.aeGroups.length === 0) {
    error.value.push('At least one AE Group must be provided.');
  }

  if (error.value.length > 0) return false;
  

  return true;
}



const executeStep = async () => {

  return true;
}



onMounted(() => {


});

defineExpose({ validateStep, executeStep });

</script>